// Sidebar
export const MOBILE_BREAKPOINT = 1024;
export const SIDEBAR_COOKIE_NAME = "sidebar_state";
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
export const SIDEBAR_WIDTH = "16rem";
export const SIDEBAR_WIDTH_MOBILE = "18rem";
export const SIDEBAR_WIDTH_ICON = "3rem";
export const SIDEBAR_KEYBOARD_SHORTCUT = "b";

export const DEFAULT_DEBOUNCE_IN_MS = 300;

export const DEFAULT_PAGE_SIZE = 25;

export const DATE_FORMAT_MMMDYYYY = "MMM D, YYYY";
export const DATE_FORMAT_DDMMYYYY = "DD/MM/YYYY";
export const DATE_PLACEHOLDER = "— / — / ——";

// TEMP CONSTANT FOR DURATION
export const DURATION = 3; // hours

// PostgreSQL error codes
export const PG_ERROR_UNIQUE_VIOLATION = "23505";

export const PHONE_NUMBER_MASK = "(999) 999-9999";

export const SIN_NUMBER_MASK = "999 999 999";

export const SKILL_EVALUATION_MIN = 1;
export const SKILL_EVALUATION_MAX = 5;

export const DEFAULT_PROVINCE_PREFIX = "ON"; // Ontario

export const DEFAULT_COLOR = "#000000"; // Black

export const EVALUATION_VALUE_NA = "n/a";

export const LESSON_PLAN_FILE_NAME = "plan.pdf";

export const SUPPORT_EMAIL = "techsupport-ttcc@mindsea.com";

// Company info
export const COMPANY_NAME = "Transport Training Centres of Canada";
export const COMPANY_ADDRESS = "2565 Kingsway Blvd Sudbury, Ontario P3B 2G1";
export const COMPANY_PHONE = "(705) 222-8822";
export const COMPANY_EMAIL = "info@ttcc.ca";

export const INVOICE_FOOTER_TEXT =
  "Make cheques payable to Transport Training Centres of Canada. Net 30. Late payments may be subject to a service charge.";
